/// <reference types="reflect-metadata"/>
import { warn } from "vue";
import { obtainSlot, optionNullableMemberDecorator } from "vue-facing-decorator/dist/esm/utils";
import { reflectMetadataIsSupported } from "./utils";
export const decorator = optionNullableMemberDecorator(function (proto, name, option) {
    const slot = obtainSlot(proto);
    const map = slot.obtainMap("props");
    // code from https://github.com/kaorun343/vue-property-decorator/blob/master/src/helpers/metadata.ts
    // to generate "type" option from metadata
    if (reflectMetadataIsSupported) {
        option ??= {};
        if (!Array.isArray(option) &&
            typeof option !== "function" &&
            !option.hasOwnProperty("type") &&
            typeof option.type === "undefined") {
            const type = Reflect.getMetadata("design:type", proto, name);
            if (type !== Object) {
                option.type = type;
            }
        }
    }
    else if (process.env.NODE_ENV !== "production") {
        warn(`Metadata reflection is not available, type for prop "${name}" will not be set automatically.`);
    }
    const opt = Object.assign({}, option);
    map.set(name, opt);
});
//# sourceMappingURL=props.js.map